<template>
    <div>
        <div class="vod-summary-title">
            {{ webinar.title }}
        </div>
        <div
            :style="isMobile ? 'display:block' : 'display:flex'"
            style="margin-top: 1rem;"
        >
            <div class="summary-image">
                <img :src="webinar.thumbnail" />
            </div>
            <div class="summary-list">
                <h3 v-if="!isMobile">{{ 'Zawartość' }}</h3>
                <ul v-if="!webinar.customContent">
                    <li>Test wiedzy z wyłożonego materiału</li>
                    <li>Zaświadczenie o ukończeniu E-szkolenia</li>
                </ul>
                <ul v-if="webinar.customContent">
                    <li
                        :key="index"
                        v-for="(content, index) in webinar.customContent"
                    >
                        {{ content }}
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        webinar: Object
    },
    computed: {
        isMobile() {
            return this.$store.getters['source/isMobile']
        }
    }
}
</script>
<style lang="scss" scoped>
ul {
    padding: 0 1rem;
}
li {
    margin-bottom: 0.5rem;
}
.vod-summary-title {
    font-size: 2rem;
    font-family: $input-family;
}
.summary-image {
    flex: 2;

    img {
        width: 100%;
    }
}
.summary-list {
    font-size: 1.2rem;
    margin-left: 2rem;
    flex: 4;
    line-height: 1.4rem;

    div {
        margin-bottom: 0.2rem;
    }

    h3 {
        margin: 0;
        margin-bottom: 0.5rem;
        font-size: 1.4rem;
        text-transform: uppercase;
    }
}
@media (max-width: 1000px) {
    .vod-summary-title {
        font-size: 1.5rem;
        font-family: $header-family;
    }
}
.summary-list {
    ul {
        padding: 0;
        list-style-type: none;
        margin: 0;
        margin-top: 1rem;
        margin-left: -2rem;

        li {
            margin-top: 0.2rem;
            font-family: $input-family;
            &::before {
                content: '\2022';
                color: $accent-apple;
                font-size: 40px;
                margin-right: 0.3rem;
                position: relative;
                top: 0.375rem;
            }
        }
    }
}
</style>
